<template>
  <!-- Modal -->
    <b-modal :id="'account' + this.account.id" centered="centered" title="Chi tiết tài khoản" hide-footer>
        <div class="modal-body">
            <div class="alert alert-danger" style="display:none"></div>
            <table class="table table-bordered table-acc-detail">
                <th colspan="2" class="text-center">
                    <span id="acc-info">Thông tin tài khoản</span>
                </th>
                <tr>
                    <td class="col-sm-3">Tài khoản:</td>
                    <td class="col-sm-9">{{this.account.username}}</td>
                </tr>
                <tr>
                    <td class="col-sm-3">Game:</td>
                    <td class="col-sm-9 text-uppercase text-danger">{{this.category.slug}}</td>
                </tr>
                <tr>
                    <td class="col-sm-3">Gói:</td>
                    <td class="col-sm-9 text-uppercase text-danger">{{this.package == null ? 'RANDOM' : this.package.name}}</td>
                </tr>
                <tr>
                    <td class="col-sm-3">Số tiền:</td>
                    <td class="col-sm-9 text-bold text-warning">-{{this.price}}<sups class="text-muted">đ</sups></td>
                </tr>
                <tr>
                    <td class="col-sm-3">Mật khẩu:</td>
                    <td class="col-sm-9">{{password}}</td>
                </tr>
                <tr>
                    <td class="col-sm-3">Mã đăng nhập:</td>
                    <td class="col-sm-9" id="acc-price">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="login-code-pc">
                                <textarea cols="18" rows="2" :value="this.account.login_code" class="border-0" readonly></textarea>
                            </div>
                            <div class="login-code-sp">
                                <textarea cols="8" rows="2" :value="this.account.login_code" class="border-0" readonly></textarea>
                            </div>
                            <div class="d-flex">
                                <button v-show="!this.fetched && this.account.login_code" @click="getLoginCode()"
                                        class="btn btn-primary btn-radius btn-getcode">Lấy mã</button>
                                <svg v-show="this.fetched && this.account.login_code" @click="copyCode()" aria-hidden="true" height="16" viewBox="0 0 16 16" version="1.1" width="16" data-view-component="true" class="octicon octicon-copy js-clipboard-copy-icon m-2">
                                    <path fill-rule="evenodd" d="M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z"></path><path fill-rule="evenodd" d="M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0114.25 11h-7.5A1.75 1.75 0 015 9.25v-7.5zm1.75-.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25h-7.5z"></path>
                                </svg>
                                <span v-show="this.fetched && this.account.login_code" class="m-1">{{this.times}}s</span>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="col-sm-3">Ghi chú:</td>
                    <td class="col-sm-9">{{this.account.note}}</td>
                </tr>
            </table>
        </div>

        <div class="modal-footer">
            <b-button class="btn btn-secondary col-sm-3" block @click="$bvModal.hide('account' + account.id)">Đóng</b-button>
        </div>
    </b-modal>
</template>
<script>
import { authenticator } from 'otplib';
export default {
  props: {
    account: {
      Type: Object,
      default() {
        return {};
      }
    },
    category: {
      Type: Object,
      default() {
        return {};
      }
    },
    package: {
      Type: Object,
      default() {
        return {};
      }
    },
    price: {
      Type: Object,
      default() {
        return '';
      }
    },
    password: {
      Type: Object,
      default() {
        return '';
      }
    }
  },
  watch: {
  },
  data() {
    return {
      accountDataSet: this._.clone(this.account),
      fetched: false,
      times: 0,
    }
  },
  methods: {
    getLoginCode() {
      this.account.login_code = authenticator.generate(this.account.login_code);
      this.fetched = !this.fetched;
      this.times = 30;
      this.countDown();
    },
    copyCode() {
      navigator.clipboard.writeText(this.account.login_code);
    },
    countDown() {
      const stopCountdown = setInterval(() => {
        this.times = this.times - 1;
        if (!this.times) {
          clearInterval(stopCountdown);
          this.fetched = !this.fetched;
          this.account.login_code = this.accountDataSet.login_code;
        }
      }, 1000);
    }
  }
}
</script>

<style></style>
